var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.tags),function(tag,index){return _c('v-chip',{key:index,staticClass:"ma-2",attrs:{"small":"","to":("/" + _vm.link + "/" + tag)}},[_vm._v(" "+_vm._s(tag)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }